<template>

  <v-responsive class="pa-0" @dragover.prevent @drop.prevent="cameraDrop" @mouseenter="mouseOver" @mouseleave="mouseLeft" :id="selfIndex+'player'">
    <v-container class="ma-0 pa-0" fill-height fluid > 
      <v-row no-gutters class="pa-0 ma-0" dense ref="controlsRow"> 
        <v-col class="pa-0 pt-1 ma-0 ml-2" cols=1>
         <!-- <p v-if="videoplaying" class="fieldName"> {{resource.name}}</p>-->
        </v-col>
        <v-col class="pa-0 ma-0" cols=1>
           <v-tooltip bottom v-if="videoplaying">
            <template v-slot:activator="{ on }">
              <v-btn
                class="pa-0 ma-0 mt-n2 btn-close"
                v-on="on"
                color="transparent"
                rounded
                depressed
                fab
                absolute
                right
                @click.native="clickToStopVideo()"
                width="50px"
              ><v-icon 
                :small="mobile" width="40px">mdi-close-circle</v-icon></v-btn>
            </template>
            <span>Cerrar stream en vivo</span>
          </v-tooltip>         
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0" width="100%" >
        <v-col cols=12 class="pa-0" v-resize="onResize" width="100%" style="background:#222" :style="{backgroundColor:bgcolor}" >
          <div ref="videoContainer" id="videoContainer" class="d-flex mt-1">
            <video 
            ref="video" id="video" autoplay muted  :height="height"></video>
            <p v-if="videoplaying" class="fieldName title-video"> {{resource.name}}</p>
            <v-img v-if="videoplaying" :src="require('../../../public/static/logo_ultraip.png')" class="watermark" :width="logowidth" :style="{left:watermarkOffset}" ></v-img>
            <v-btn 
              v-if="videoplaying"
              class="fsbutton" 
              :small="mobile"
              @click.native="toggleFullscreenMode"
              @mouseup.stop
              text
              :key="'close'+selfIndex"
            > 
              <v-icon v-if="!fullscreenMode"  :small="mobile" >mdi-arrow-expand-all</v-icon>
              <v-icon v-else  :small="mobile">mdi-arrow-collapse-all</v-icon>
            </v-btn>     
          </div>
          
          <v-overlay class="pa-0 ma-0 "
            absolute="absolute"
            v-if="!videoplaying"
            opacity="0"
          >
            <v-row justify="center"> 
              <v-progress-circular
                v-if="isLoading"
                indeterminate
                color="primary"
                :size="90"
                class="pl-5"
              />
            </v-row>
            <p>{{messageComputed}}</p>
          </v-overlay>   
        </v-col>   
      </v-row>
    </v-container>
  </v-responsive>
</template>

<script>
  export default {
    name: 'VideoStream',
    props:{ 
      message: {
        type: String,
        default: "Select an inputchannel"
      },
      selfIndex: {
        type:Number,
        default: -1
      },
      height: {
        type: Number,
      },
      resource: {
        type: Object,
        default: ()=>{
          return {
            bd:'', 
            id: '', 
            name:'', 
            type:''
          }
        }
      }
    },
    data() {
      return {
        websocket: undefined,
        count: 0,
        mediaSource: undefined,
        sourceBuffer: undefined,
        canAppendToMediaSource: false,
        buffers: {
          video: [],
        },
        // elements
        video: undefined,
        //sizes
        firstSet: false,
        windowSize: {
          x: 0,
          y: 0
        },
        videoAspect: {
          h: 0,
          w: 0
        },
        videoContainerWidth: 0,
        logowidth:0,
        watermarkOffset:0,
        //
        fullscreenMode: false,
        overlay: true,
        videoplaying: false,
        displayMessage: "Select inputchannel...",
        isLoading: false,
        socketTimeout: undefined,
      }
    },
    mounted() {
      if(this.resource.id==='') return null
      this.isLoading = true;
      var hasMediaSource = "MediaSource" in window;
      if (hasMediaSource) {
        this.startStreaming(this.resource.id);
        this.createMedia();
        this.socketTimeout = setTimeout(this.timeoutHandler, 10000)
      } else {
        var video = this.$refs.video;
        var src = this.$config.VUE_APP_STREAMING_SERVER || process.env.VUE_APP_STREAMING_SERVER;
        src = "http"+src.substring(2,src.length);
        video.src=src + "/hls/"+this.resource.id+"/main.m3u8?token="+ this.$store.getters.getAccessToken
        video.onplay= () => {
          this.videoplaying=true;
          this.adjustSeveralSizes();
        };
      }
      this.videoContainer = document.getElementById("videoContainer")
      this.video = document.getElementById("video")
      
    },
    beforeDestroy(){
      if(this.websocket !== undefined) {
        this.websocket.onclose = function () { console.log('websocket closed for stream: ', this.key)}
        this.websocket.close();       
      }
    },
    computed: {
      bgcolor: {
        get(){
          return (this.videoplaying)? 'black': 'transparent'
        }
      },
      mobile: {
        get(){
          return ((this.$vuetify.breakpoint.name=="xs")||(this.$vuetify.breakpoint.name=="sm"))
        }
      },
     // logo:{get(){return url.default}},
      videoheight: {
        get(){
          var windowHeight =  this.windowSize.y 
          if((this.mobile)&&(this.$store.getters.getDrawer)) {
            windowHeight /= 2
          }
          var height= windowHeight - windowHeight*(90/windowHeight)
          var res=0
          if((this.videoContainer!==undefined)&&(this.videoContainer.offsetWidth < height *16 /9))
            res += (this.videoContainer.offsetWidth * 9 / 16)
          else
            res += windowHeight - windowHeight*(90/windowHeight)
          if(this.videoplaying){
            // 44 is the height of the controls row bar
            var rowBarPercentage =  44  / (res - res * (40/res))
            var total = res - res * (40/res) 
            // to calculate video final height I reduced the height passed as a prop which is the player total height and substract the height used for the controls row bar
            return total - total * rowBarPercentage
          }
          return res - res * (40/res) 
          //- this.height*.08
        }
      },
      innerHeight: {
        get(){
          return this.height - this.height * (40/this.height)
        }
      },
      messageComputed: {
        get(){
          if(this.$store.getters.getResourcesLoading){
            return "Cameras list loading..."
          } else if(this.isLoading) {
            return "Camera connection being established..."              
          } else
            return this.displayMessage
        },
        set(){
          return null
        }
      },
      player:{
        get(){
          return []
        },
        set(value){
          this.$emit('changeComponent',{index:this.selfIndex, id:value[0].id,name:value[0].title, operation:"add"})
        }
      }
    },
    methods: {
      timeoutHandler(){
        
        if(this.videoplaying)
          return null
        if(this.websocket !== undefined){
          this.websocket.close()
        }
        this.isLoading = false
        this.displayMessage = 'NO VIDEO AVAILABLE'
      },
      updateEndHandler() {
        var video = this.$refs.video;
        //hack to get safari on mac to start playing, video.currentTime gets stuck on 0
        if (this.mediaSource.duration !== Number.POSITIVE_INFINITY && video.currentTime === 0 && this.mediaSource.duration > 0) {
          video.currentTime = this.mediaSource.duration - 1;
          this.mediaSource.duration = Number.POSITIVE_INFINITY;
          video.play()
        }
        if (this.buffers.video.length) {
          try{
            this.sourceBuffer.appendBuffer(this.buffers.video.shift());
          }catch(e){
            console.log('append1: ', e , HTMLMediaElement.error)
          }
        } else {
          this.canAppendToMediaSource = true;
        }
       
      },
      sourceOpenHandler() {
        
        if(this.mediaSource.sourceBuffers.length >0) {
          this.mediaSource.removeSourceBuffer(this.mediaSource.sourceBuffers)
          //this.mediaSource.sourceBuffers.remove(this.mediaSource.sourceBuffers.buffered.start(),this.mediaSource.sourceBuffers.buffered.end() )
        }
        if (!MediaSource.isTypeSupported('video/mp4;codecs="avc1.64001e"')) {
          alert('Unsupported mime type');
          return;
        }
        this.sourceBuffer = this.mediaSource.addSourceBuffer('video/mp4;codecs="avc1.64001e"');
        this.sourceBuffer.mode = 'segments';
        this.sourceBuffer.addEventListener('updateend', this.updateEndHandler);
        this.canAppendToMediaSource = true;        
      },
      initMedia(){
        this.mediaSource = new MediaSource();
        this.mediaSource.addEventListener('sourceopen', this.sourceOpenHandler);
      },        
      createWS(stream) {
        //console.log("createWs");
        this.websocket = new WebSocket((this.$config.VUE_APP_STREAMING_SERVER || process.env.VUE_APP_STREAMING_SERVER) + "/?id="+stream + "&token="+ this.$store.getters.getAccessToken);
        this.websocket.binaryType = 'arraybuffer';
        this.websocket.onopen = function () {
          console.log("ws connected");
          this.stateText = "connected";
        }.bind(this);
        this.websocket.onclose = function (e) {
          console.log("ws closed", e);
          this.stateText = "closed";
          this.displayMessage = 'NO VIDEO AVAILABLE'
          //this.$emit('changeComponent', 'NO VIDEO AVAILABLE')
          if(this.isLoading) this.isLoading= false
        }.bind(this)
        this.websocket.onerror = function (e) {
          console.log("ws error", e);
          this.stateText = "error";
          this.displayMessage = 'NO VIDEO AVAILABLE'
          //this.$emit('changeComponent', 'NO VIDEO AVAILABLE')
          if(this.isLoading) this.isLoading= false
        }.bind(this)
        this.websocket.onmessage = this.onWebsocketMessage;
      },
      createMedia() {
        this.$refs.video.src = window.URL.createObjectURL(this.mediaSource);
      },
      startStreaming(stream){
        this.initMedia();
        this.createWS(stream);
      },
      videoIsPlaying(){
        return this.$refs.video.currentTime > 0 && !this.$refs.video.paused && !this.$refs.video.ended 
        && this.$refs.video.readyState > 2;
      },
      onWebsocketMessage(event) {
        if (typeof (event.data) == 'string') {
          if(this.videoplaying) this.videoplaying= !this.videoplaying;
          let js = JSON.parse(event.data);
          const eStatus = js.status;
          switch(eStatus){
            case 'no_connection':
              this.displayMessage = "Source not connected...\n Wait or contact administrator.";
              break;
            case 'framesource_no_connection':
              this.displayMessage = "Frame source not connected...\n Wait or contact administrator.";
              break;
            case 'framesource_disconnected':
              this.displayMessage = "Frame source disconnected...\n Wait or contact administrator.";
              break;
            case 'framesource_EOS':
              this.displayMessage = "End of stream found.\n Something is not right!";
              break;
          }
          return
        }        
        if(!this.videoplaying) this.videoplaying= !this.videoplaying;
        let data = new Uint8Array(event.data);
        
        if (this.canAppendToMediaSource === true) {
          try{
            this.sourceBuffer.appendBuffer(data);
          }catch(e){
            console.log('append2: ', e)
          }
          this.canAppendToMediaSource = false;
        } else {
          this.buffers.video.push(data);
        }
        if((this.video.videoHeight!==0)&&(!this.firstSet)){ 
          this.firstSet = true
          this.adjustSeveralSizes()
        }
      },
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        this.adjustSeveralSizes()
      },
      adjustSeveralSizes(){
        this.videoContainer = document.getElementById("videoContainer")
        this.video = document.getElementById("video")
        this.logowidth = (this.videoheight *16 /9) * 0.075
        var videoWidthPercentage = this.video.videoHeight * 100 / this.video.videoWidth
        this.watermarkOffset = (this.videoContainer.offsetWidth -this.videoheight*100/videoWidthPercentage)/2 + 20+ "px"
      },
      clickToStopVideo(){
        this.$store.commit('setResource', {id:this.resource.id, name:this.resource.name, operation:"remove"})
      },
      toggleFullscreenMode(){
        //var elem = document.getElementById('fullscreen');
        var isFirefox = typeof InstallTrigger !== 'undefined';
        if(!isFirefox){
          if(document.webkitFullscreenElement) {
            this.$refs.video.className=""
            document.webkitCancelFullScreen();
            this.fullscreenMode = false
          }
          else {
            this.$refs.videoContainer.webkitRequestFullScreen();
            this.$refs.video.className="fullscreen"
            this.fullscreenMode = true
          }
        } else{
          if(document.fullscreenElement) {
            this.$refs.video.className=""
            document.exitFullscreen();
            this.fullscreenMode = false
          }
          else {
            this.$refs.videoContainer.requestFullscreen();
            this.$refs.video.className="fullscreen"
            this.fullscreenMode = true
          }
        }
      },
      cameraDrop(event) {
        var markerInfo = this.$store.getters.getMarkerInfo
        if(markerInfo.id===undefined)
          this.$emit('changeComponent',{index:this.selfIndex, id:event.dataTransfer.getData('id'),name:event.dataTransfer.getData('name'), operation:"add"})
        else {
          this.$emit('changeComponent',{index:this.selfIndex, id:markerInfo.id,name:markerInfo.name, operation:"add"})
          this.$store.dispatch('setOffMarkerDragging')
        }
      },
      mouseOver(){
        this.$store.commit('setPlayerHovered', this.selfIndex)
      },
      mouseLeft(){
        this.$store.commit('setPlayerHovered', undefined)
      }
    }
  }
</script>
<style scoped>
.fsbutton{
  display: inline-block;
  width: 32px;
  height: 32px;
  position: absolute;
  bottom: 5px;
  right: 10px;
  cursor: pointer;
}
.fullscreen{
  height: 100%;
  width: 100%
}
.videoContainer{
  background-color:black;
}
.ultraip {
  background-color: black;
  left: var(--watermark-offset)
}
.policia {
  right: var(--watermark-offset)
}
.watermark{
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  top: 50px;
  left: 5px;
}
video::-webkit-media-controls {
  display:none !important;
}
.fieldName {
  white-space: nowrap
}
.title-video{
  position: absolute;
  left:0%;
  padding: 2px;
  padding-left: 15px;
  width: 100%;
  background: rgba(0,0,0,0.6);
}
.btn-close{
  top: 2px;
  right: 15px;
}

.video-width{
  width: 95%;
  
}

@media (max-width: 950px) {
  .btn-close{
    right: 5px;
  }
  .fsbutton{
    right: 16px;
  }
}
@media (max-width: 850px) {
  .title-video{
    padding: 2px;
  }
  
}


@media (max-width: 650px) {
  .title-video{
    padding: 2px;
  }
  
  .video-width{
    width: 95%;
  }
  .btn-close{
  right: 0px;
}
}
@media (max-width: 450px) {
  .video-width{
    width: 93%;
  }
}

</style>